import { Component, OnInit } from '@angular/core';
import {
  trigger,
  transition,
  query,
  stagger,
  style,
  animate,
  keyframes,
} from '@angular/animations';

export interface MenuItem {
  id: number;
  title: string;
  imageUrl: string;
  routerLink?: string;
}

export const MENUITEMS = [
  {
    id: 1,
    title: 'تمامی آیتم‌ها',
    routerLink: '10',
    imageUrl: '../../../assets/Img/fleetdiag/تمامی آیتم ها.png',
  },
  {
    id: 2,
    title: 'اطلاعات پایه',
    routerLink: '1',
    imageUrl: '../../../assets/Img/fleetdiag/اطلاعات پایه.png',
  },
  {
    id: 3,
    title: 'سیستم سوخت',
    routerLink: '2',
    imageUrl: '../../../assets/Img/fleetdiag/سیستم سوخت.png',
  },
  {
    id: 4,
    title: 'هوا و دریچه گاز',
    routerLink: '3',
    imageUrl: '../../../assets/Img/fleetdiag/هوا و دریچه گاز.png',
  },
  {
    id: 5,
    title: 'جرقه و زمانبندی',
    routerLink: '4',
    imageUrl: '../../../assets/Img/fleetdiag/جرقه و زمانبندی.png',
  },
  {
    id: 6,
    title: 'سنسورهای اکسیژن',
    routerLink: '5',
    imageUrl: '../../../assets/Img/fleetdiag/سنسورهای اکسیژن.png',
  },
  {
    id: 7,
    title: 'آلایندگی',
    routerLink: '6',
    imageUrl: '../../../assets/Img/fleetdiag/آلایندگی.png',
  },
  {
    id: 8,
    title: 'کاتالیزور و اگزوز',
    routerLink: '7',
    imageUrl: '../../../assets/Img/fleetdiag/کاتالیزور و اگزوز.png',
  },
  {
    id: 10,
    title: 'گشتاور و بار موتور',
    routerLink: '9',
    imageUrl: '../../../assets/Img/fleetdiag/گشتاور و بار موتور.png',
  },
];

@Component({
  selector: 'app-fleetdiag-live-parameters',
  templateUrl: './fleetdiag-live-parameters.component.html',
  styleUrls: [
    './fleetdiag-live-parameters.component.css',
    '../../fleetdiag-dashboard-pro.component.scss',
  ],
  animations: [
    trigger('cardsDeal', [
      transition('* => *', [
        query(
          ':enter',
          [
            style({
              opacity: 0,
              transform: 'translateY(-60px) rotate(-15deg) scale(0.8)',
            }),
            stagger(80, [
              animate(
                '500ms cubic-bezier(0.34, 1.56, 0.64, 1)',
                keyframes([
                  style({
                    opacity: 0,
                    transform: 'translateY(-60px) rotate(-15deg) scale(0.8)',
                    offset: 0,
                  }),
                  style({
                    opacity: 0.7,
                    transform: 'translateY(10px)  rotate(3deg)   scale(1.05)',
                    offset: 0.7,
                  }),
                  style({
                    opacity: 1,
                    transform: 'translateY(0)      rotate(0deg)   scale(1)',
                    offset: 1,
                  }),
                ]),
              ),
            ]),
          ],
          { optional: true },
        ),
      ]),
    ]),
  ],
})
export class FleetdiagLiveParametersComponent {
  menuItems: MenuItem[] = MENUITEMS;

}
